import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import "./styles/custom-bootstrap.scss";

const rootElement = document.getElementById("root");

if(!rootElement) {
  throw new Error("Root element not found. Check your index.html.");
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);


root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);
